export default __webpack_public_path__ + "static/media/icon-calendar-gray.4f24425a.svg";